import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=3048443d&scoped=true&"
import script from "./TransactionsList.vue?vue&type=script&lang=ts&"
export * from "./TransactionsList.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=3048443d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3048443d",
  null
  
)

export default component.exports